import axios from 'axios'

import BaseURL from '../config'
import { mapBaseRL } from '../config'
import store from '../store'
import { fetchMerchantId, removeDataFromStorage } from '../utils'

import { showLoader, hideLoader } from '../containers/utility/actions'

const getHeaders = (skipTokenCheck) => {
  const token = localStorage.getItem('access-token') || '';
  if (!skipTokenCheck && !token) {
    // remove all the key from localStorage
    removeDataFromStorage();
    // clear the redux data
    redirectToLogin();
    return;
  }
  const obj = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (token)
    obj.access_token = token;
  return obj;
}

function redirectToLogin() {
  store.dispatch({
    type: 'logout-success',
  });
}

export const getCommonParams = (essentialParams = []) => {
  if (!Array.isArray(essentialParams)) return {};
  const params = {};
  params.merchant = fetchMerchantId() || localStorage.getItem("merchant-id");

  return essentialParams.reduce((acc, key) => {
    if (params[key]) {
      acc[key] = params[key];
    }
    return acc;
  }, {});
};

export const getCall = (url, query = {}, essentialParams, extraHeaders = {}) => {
  let headers = getHeaders()
  store.dispatch(showLoader())
  if (Object.keys(extraHeaders).length) {
    headers = Object.assign({}, headers, extraHeaders);
  }
  return axios
    .get(BaseURL + url, { headers, params: { ...query, ...getCommonParams(essentialParams) } })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const postCall = (url, data = {}, skipTokenCheck, extraHeaders = {}) => {
  let headers = getHeaders(skipTokenCheck);
  store.dispatch(showLoader());
  if (Object.keys(extraHeaders).length);
  headers = Object.assign({}, headers, extraHeaders);

  // retrieving essential params from data and deleting them from data

  const essentialParams = data.__essentialParams__ || null;
  delete data.__essentialParams__;

  return axios
    .post(BaseURL + url, data, { headers, params: essentialParams ? getCommonParams(essentialParams) : {} })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error;
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const putCall = (url, data = {}) => {
  const headers = getHeaders()
  store.dispatch(showLoader());

  // retrieving essential params from data and deleting them from data

  const essentialParams = data.__essentialParams__ || null;
  delete data.__essentialParams__;

  return axios
    .put(BaseURL + url, data, { headers, params: essentialParams ? getCommonParams(essentialParams) : {} })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const deleteCall = (url, data = {}) => {
  const headers = getHeaders()
  store.dispatch(showLoader())
  return axios
    .delete(BaseURL + url, { headers })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const patchCall = (url, payload = {}, params = {}) => {
  const headers = getHeaders()
  store.dispatch(showLoader())
  return axios
    .patch(BaseURL + url, payload, { headers, params })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const genericGetCall = (url, query = {}, essentialParams) => {
  const headers = getHeaders()
  store.dispatch(showLoader())
  return axios
    .get(url, { headers, params: { ...query, ...getCommonParams(essentialParams) } })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const mmiKeyGetCall = (url, query = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  store.dispatch(showLoader())
  return axios
    .get(url, { headers, params: query })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const genericPostCall = (url, data = {}) => {
  store.dispatch(showLoader())
  const headers = getHeaders();
  // retrieving essential params from data and deleting them from data

  const essentialParams = data.__essentialParams__ || null;
  delete data.__essentialParams__;

  return axios
    .post(url, data, { headers, params: essentialParams ? getCommonParams(essentialParams) : {} })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error;
    })
    .then(tempData => { store.dispatch(hideLoader()); return tempData; })
}

export const placesPostCall = (url, data = {}) => {
  // store.dispatch(showLoader())
  const headers = getHeaders()
  return axios
  .post(mapBaseRL + url, data, { headers })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error;
    })
    .then(tempData => { return tempData; })
}


export const genericDeleteCall = (url, data = {}) => {
  const headers = getHeaders();
  store.dispatch(showLoader());
  return axios
    .delete(BaseURL + url, {
      headers,
      data
    })
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        removeDataFromStorage();
        redirectToLogin();
      }
      return error;
    })
    .then(tempData => {
      store.dispatch(hideLoader());
      return tempData;
    });
};
